import React from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";

const AttendancePopup = ({ data, staffNameDD, shiftDD, designationOptions, statusOptions, permissionTypeOptions, permissiondurationOptions }) => {
  // Find selected options for dropdowns
  const selectedStaff = staffNameDD.find(
    (item) => item.value === data?.MstStaffId
  );
  const selectedShift = shiftDD.find(
    (item) => item.value === data?.MstShiftId
  );
  const selectedDesignation = designationOptions.find(
    (item) => item.value === data?.MstDesignationId
  );
  const selectedStatus = statusOptions.find(
    (item) => item.value === data?.MstStatusId
  ) || { value: "", label: "" }; // Fallback to prevent undefined
  const selectedPermissionType = permissionTypeOptions.find(
    (item) => item.value === data?.MstPermissionId
  ) || { value: "", label: "" }; // Fallback to prevent undefined
  const selectedPermissionDuration = permissiondurationOptions.find(
    (item) => item.value === data?.MstPermissiondurationId
  ) || { value: "", label: "" }; // Fallback to prevent undefined

  // Format time fields to HH:mm
  const formatTime = (time) => {
    if (!time) return "";
    const date = new Date(time);
    return isNaN(date.getTime()) ? "" : date.toISOString().split("T")[1].slice(0, 5);
  };

  return (
    <>
      <div className="px-4">
        <h2 className="text-lg font-semibold text-neutral-700 px-4 mb-4">Attendance Details</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
          <AutoDropDown
            title="Staff"
            name="staffName"
            options={staffNameDD}
            placeholder="Select Staff"
            selectedOption={selectedStaff}
            Class="custom-class"
            classStar="text-red-500"
            disabled={true}
          />
          <InputText
            inputType="date"
            title="Date"
            name="salaryDate"
            content={data?.Date?.split("T")[0] || ""}
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          />
      <InputText
  inputType="text"
  title="Position"
  name="position"
  content={data?.Position || ""}
  disabled={true}
  classStar="text-red-500"
/>
       
          <AutoDropDown
            title="Shift"
            name="shift"
            options={shiftDD}
            placeholder="Select Shift"
            selectedOption={selectedShift}
            Class="custom-class"
            classStar="text-red-500"
            disabled={true}
          />
          <DropDown
            title="Status"
            name="status"
            options={statusOptions}
            selectedOption={selectedStatus.value} // Pass value instead of object
            classStar="text-red-500"
            disabled={true}
            isRequired={false}
          />
          <DropDown
            title="Permission Type"
            name="permissiontype"
            options={permissionTypeOptions}
            selectedOption={selectedPermissionType ? selectedPermissionType.value : ""}
            placeholder="Select Permission Type"
            classStar="text-red-500"
            disabled={true}
            isRequired={false}
          />
          <DropDown
            title="Permission Duration"
            name="permissionduration"
            options={permissiondurationOptions}
            selectedOption={selectedPermissionDuration ? selectedPermissionDuration.value : ""}
            placeholder="Select Permission Duration"
            classStar="text-red-500"
            disabled={true}
            isRequired={false}
          />
        </div>

        <h2 className="text-lg font-semibold text-neutral-700 mt-6 px-4 mb-4">Forenoon Details</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
          <InputText
            inputType="time"
            title="In Time"
            name="forenoonInTime"
            content={(data?.MInTime)} // Use formatTime
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          />
          <InputText
            inputType="time"
            title="Out Time"
            name="forenoonOutTime"
            content={(data?.MOutTime)} // Use formatTime
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          />
          <InputText
            inputType="text"
            title="Remarks"
            name="remarksForenoon"
            content={data?.MRemarks || ""}
            disabled={true}
            inputClassName="w-full"
          />
        </div>

        <h2 className="text-lg font-semibold text-neutral-700 mt-6 px-4 mb-4">Afternoon Details</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
          <InputText
            inputType="time"
            title="In Time"
            name="afternoonInTime"
            content={(data?.AInTime)} // Use formatTime
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          />
          <InputText
            inputType="time"
            title="Out Time"
            name="afternoonOutTime"
            content={(data?.AOutTime)} // Use formatTime
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          />
          <InputText
            inputType="text"
            title="Remarks"
            name="remarksAfternoon"
            content={data?.ARemarks || ""}
            disabled={true}
            inputClassName="w-full"
          />
          <InputText
            inputType="text"
            title="Total Hours"
            name="totalHours"
            content={data?.Totalhours?.toString() || ""}
            classStar="text-red-500"
            disabled={true}
            inputClassName="w-full"
          />
        </div>
      </div>
    </>
  );
};

export default AttendancePopup;